export default __webpack_public_path__ + "static/media/flyer.12d8f58d.svg";